/*
  Allows Users to switch between Organizations

    only if they are part of multiple organizations.

*/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
   UncontrolledDropdown,
   DropdownToggle,
   DropdownMenu,
   DropdownItem,
   Tooltip,
} from 'reactstrap';
import Swal from 'sweetalert2';
import { getLoggedInUserDetails } from 'redux/auth/authService';
import { OrganizationIcon } from 'app/employer/vectors';
import { switchOrganization } from './ImpersonationDropdown/EmployerImpersonation/ImpersonationService';

class OrganizationSwitch extends Component {
   constructor(props) {
      super(props);
      this.state = {
         showToolTip: false,
      };
      this.switchOrganization = this.switchOrganization.bind(this);
   }

   componentWillUnmount() {
      if (this.subscription) {
         this.subscription.unsubscribe();
      }
   }

    toggleToolTip = () => {
       this.setState({
          showToolTip: !this.state.showToolTip,
       });
    }

    switchOrganization(event, org) {
       event.preventDefault();
       if (org.id !== this.props.user.organizationId) {
          this.subscription = switchOrganization(org.id).subscribe(
             (data) => {
                if (data.response.toLowerCase() === 'success') {
                   Swal.fire({
                      type: 'success',
                      title: 'Switching Organization',
                      text: 'Switching Organization success.',
                   }).then(() => {
                      this.props.getUserDetails();
                   });
                } else {
                   Swal.fire({
                      type: 'error',
                      title: 'Switching Organization',
                      text: data.message,
                   });
                }
             },
          );
       } else {
          Swal.fire({
             type: 'error',
             title: 'Switching Organization',
             text: `Already logged in as ${ org.name }.`,
          });
       }
    }

    render() {
       const { user } = this.props;
       return (
          <>
             {user && user.organizations && user.organizations.length > 1 ? (
                <UncontrolledDropdown nav inNavbar className='mr-2'>
                   <DropdownToggle nav className='nav-icon dropdown-toggle'>
                      <div className='position-relative'>
                         <OrganizationIcon height={24} id='organizationSwitch' stroke='#666666' />
                         <Tooltip placement='bottom' isOpen={this.state.showToolTip} toggle={this.toggleToolTip} target='organizationSwitch' trigger='hover' >
                            Switch Organization
                         </Tooltip>
                      </div>
                   </DropdownToggle>
                   <DropdownMenu right className='dropdown-menu-lg py-0'>
                      {user.organizations.map((org) => {
                         return (
                            <DropdownItem active={+user.organizationId === org.id} key={org.id} onClick={(event) => this.switchOrganization(event, org)}>{org.name}</DropdownItem>
                         );
                      })}
                   </DropdownMenu>
                </UncontrolledDropdown>
             ) : (<></>)}
          </>
       );
    }
}

const mapStateToProps = (state) => {
   return {
      user: state.authReducer.loggedInUser,
   };
};

const mapDispatchToProps = (dispatch) => ({
   getUserDetails: () => dispatch(getLoggedInUserDetails()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationSwitch);
